import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export default function TimeIcon(props: any) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 19.84 19.84"
      style={{ width: `16px`, height: `16px`, color: RoutalPalette.grey1, ...props.style }}
    >
      <g>
        <path d="M9.92,19.55C4.61,19.55.29,15.23.29,9.92S4.61.29,9.92.29c5.31,0,9.63,4.32,9.63,9.63s-4.32,9.63-9.63,9.63ZM9.92,1.29C5.16,1.29,1.29,5.16,1.29,9.92s3.87,8.63,8.63,8.63,8.63-3.87,8.63-8.63S14.68,1.29,9.92,1.29Z" />
        <path d="M13.57,12.25c-.08,0-.15-.02-.22-.05l-3.65-1.83c-.17-.08-.28-.26-.28-.45v-5.48c0-.28.22-.5.5-.5s.5.22.5.5v5.17l3.37,1.69c.25.12.35.42.22.67-.09.18-.26.28-.45.28Z" />
      </g>
    </SvgIcon>
  );
}
